module.exports = __webpack_public_path__ + "img/equis.c411ce22.png";